module.exports = __webpack_public_path__ + "img/155615.2268b553.png";